export default __webpack_public_path__ + "static/media/redNotification.bf26bba8.jpg";